import React, { useEffect } from "react";
import QlikCard from "shared/components/QlikCard";
import QlikObject from "shared/components/QlikObject";

export default function LeaseRegistry({ title, pageTitle, menuItemsStrings }) {
  useEffect(() => {
    document.title = `${pageTitle} - ${title}`;
  }, [pageTitle,title]);
  return (
    <section className="content">
      <div className="content-header">
        <div className="row mb-2">
          <div className="col-md-10 col-sm-9 col-10">
            <h5 className="page-title"> {title} </h5>
            {/* <QlikObject
              className="page-title"
              id="CSXuDUc"
              height="35px"
              showLoader={false}
            /> */}
          </div>
          {/* <div className="col-md-2 col-sm-3 col-4">
            <QlikObject id="GqNcZ" height="35px" showLoader={false} />
          </div> */}
          <div className="col-md-2 col-sm-3 col-2">
            <QlikObject id="MmmEsfe" height="35px" showLoader={false} />
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row justify-content-start">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4">
            <QlikCard
              id="hJmJKM"
              height="35px"
              showLoader={true}
              showExport={false}
              showHeader={false}
            />
          </div>
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4">
            <QlikCard
              id="jwZcv"
              height="35px"
              showLoader={true}
              showExport={false}
              showHeader={false}
            />
          </div>
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4">
            <QlikCard
              id="PALQqdP"
              height="35px"
              showLoader={true}
              showExport={false}
              showHeader={false}
            />
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-12">
            {/* vizTable */}
            <QlikCard
              id="JSqmUq"
              height="670px"
              showLoader={true}
              showExport={true}
              showHeader={true}
              exportText = {menuItemsStrings.exportText}
              exportCompletedText = {menuItemsStrings.exportCompletedText}
              closeBtnText = {menuItemsStrings.closeBtnText}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
